import React from 'react';
import Lrn_us_mat_pcard from './lrn_us_mat_pcard.jsx';

const Lrn_us_mat= () => {
  const pages = [
    {
      title: 'Pre-K',
      description: 'Manage your account details and personal info.',
      path: "/learning/lrn_us_mat/lrn_us_mat_prek",
    },
    {
      title: 'Kindergarten',
      description: 'View your traffic reports and usage statistics.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k",
    },
    {
      title: 'First grade',
      description: 'Check your subscription status and invoices.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k1",
    },

    {
      title: 'Second grade',
      description: 'Manage your account details and personal info.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k2",
    },
    {
      title: 'Third grade',
      description: 'View your traffic reports and usage statistics.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k3",
    },
    {
      title: 'Fourth grade',
      description: 'Check your subscription status and invoices.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k4",
    },

    {
      title: 'Fifth grade',
      description: 'Manage your account details and personal info.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k5",
    },
    {
      title: 'Sixth grade',
      description: 'View your traffic reports and usage statistics.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k6",
    },
    {
      title: 'Seventh grade',
      description: 'Check your subscription status and invoices.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k7",
    },

    {
      title: 'Eighth grade',
      description: 'Manage your account details and personal info.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k8",
    },
    {
      title: 'Nineth grade',
      description: 'View your traffic reports and usage statistics.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k9",
    },
    {
      title: 'Tenth grade',
      description: 'Check your subscription status and invoices.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k10",
    },

    {
      title: 'Eleventh grade',
      description: 'Check your subscription status and invoices.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k11",
    },

    {
      title: 'Twelveth grade',
      description: 'Check your subscription status and invoices.',
      path: "/learning/lrn_us_mat/lrn_us_mat_k12",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-8">
       <div className='h-12 flex bg-[#007bff] justify-between gap-4'> 
      <div className="mx-auto max-w-4xl">
        <h1 className="mb-6 text-2xl font-bold text-gray-900">Choose a class</h1>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {pages.map((page, index) => (
            <Lrn_us_mat_pcard
              key={index}
              title={page.title}
              description={page.description}
              path={page.path}
            />
          ))}
        </div>
      </div>
    </div>
    </div>
  );
};

export default Lrn_us_mat;

